import { AlertIcon, CheckOutlinedIcon, InfoIcon, StopIcon } from "../../../assets/icons"

export const INFO_CARD_VARIANT = {
  info: "info",
  error: "error",
  warning: "warning",
  success: "success",
} as const

export type InfoCardVariant = keyof typeof INFO_CARD_VARIANT

export const INFO_CARD_ICONS = {
  [INFO_CARD_VARIANT.info]: InfoIcon,
  [INFO_CARD_VARIANT.error]: StopIcon,
  [INFO_CARD_VARIANT.warning]: AlertIcon,
  [INFO_CARD_VARIANT.success]: CheckOutlinedIcon,
} as const

export type InfoCardIcons = keyof typeof INFO_CARD_ICONS
